import React from 'react';
import moment from 'moment';
import { TextSmall } from './viewMessage.styled';
import { Switch } from 'antd';
import SmartResendDrawer from './SmartResendDrawer';

const ResendToNonOpeners = ({
  message,
  scheduleTime,
  scheduledResendMessage,
  setScheduledResendMessage,
  isResendToNonOpenersChecked,
  setIsResendToNonOpenersChecked,
}) => {
  const resendLabel =
    scheduledResendMessage.confirmResend && scheduledResendMessage.resendDate
      ? `Resend to Non-Openers on ${moment(
          scheduledResendMessage.resendDate,
          'YYYY-MM-DDTHH:mm'
        ).format('M/D/YYYY h:mm a')}`
      : 'Automatically Resend to Non-Openers';

  return (
    <>
      <TextSmall
        onClick={() => {
          setIsResendToNonOpenersChecked(!isResendToNonOpenersChecked);
        }}
      >
        <Switch
          checked={!!scheduledResendMessage.confirmResend}
          checkedChildren="ON"
          unCheckedChildren="OFF"
        />
        <>{resendLabel}</>
      </TextSmall>
      <SmartResendDrawer
        isDrawerVisible={isResendToNonOpenersChecked}
        setDrawerVisibility={setIsResendToNonOpenersChecked}
        message={message}
        scheduleTime={scheduleTime}
        scheduledResendMessage={scheduledResendMessage}
        setScheduledResendMessage={setScheduledResendMessage}
      />
    </>
  );
};

export default ResendToNonOpeners;
